module.exports = __webpack_public_path__ + "img/ep-ailes.e351134e.jpg";